export default __webpack_public_path__ + "static/media/library.c16a616c.jpg";